import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import fr from './locales/fr.json'
import es from './locales/es.json'
import ja from './locales/ja.json'
import ar from './locales/ar.json'

const resources = { en: { translation: en }, fr: { translation: fr }, es: { translation: es }, ja: { translation: ja }, ar: { translation: ar } }

const userLang = (() => {
  const langs = (navigator.languages || [navigator.language || '']).map(l => l.toLowerCase())
  for (const l of langs){ const base = l.split('-')[0]; if (resources[base as keyof typeof resources]) return base }
  return 'en'
})()

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: userLang,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })

document.documentElement.setAttribute('dir', i18n.dir())
i18n.on('languageChanged', () => document.documentElement.setAttribute('dir', i18n.dir()))

export default i18n

